import { Type, Bold, RotateCcw } from "lucide-react";
import { Card, Segmented } from "./controls";
import { RECEIPT_TEXT_ELEMENTS, TEXT_SIZES, resolveReceiptStyles } from "../../lib/ticketFormat";

export const ReceiptTextStyles = ({ s, setS }) => {
  const styles = resolveReceiptStyles(s);
  const update = (key, patch) =>
    setS({ ...s, receipt_styles: { ...styles, [key]: { ...styles[key], ...patch } } });

  return (
    <Card icon={Type} iconClass="text-slate-700" title="Tamaño de los textos" subtitle="Alto = letra estirada (como las jugadas) · Ancho = letra ensanchada · Grande = doble alto y ancho" testId="settings-text-styles">
      <div className="divide-y divide-slate-100">
        {RECEIPT_TEXT_ELEMENTS.map((el) => (
          <div key={el.key} className="py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 justify-between" data-testid={`text-style-row-${el.key}`}>
            <div className="text-sm font-semibold text-slate-900 min-w-0">{el.label}</div>
            <div className="flex items-center gap-2">
              <Segmented small options={TEXT_SIZES} value={styles[el.key].size} onChange={(v) => update(el.key, { size: v })} testIdPrefix={`text-size-${el.key}`} />
              <button
                type="button"
                onClick={() => update(el.key, { bold: !styles[el.key].bold })}
                className={`w-8 h-8 rounded-sm border-2 flex items-center justify-center transition-colors ${
                  styles[el.key].bold ? "border-blue-600 bg-blue-600 text-white" : "border-slate-200 text-slate-500 hover:border-slate-300"
                }`}
                title="Negrita"
                aria-pressed={styles[el.key].bold}
                data-testid={`text-bold-${el.key}`}
              >
                <Bold className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={() => setS({ ...s, receipt_styles: {} })}
        className="text-xs font-semibold text-slate-600 hover:text-slate-900 inline-flex items-center gap-1"
        data-testid="text-styles-reset"
      >
        <RotateCcw className="w-3 h-3" /> Restablecer tamaños predeterminados
      </button>
    </Card>
  );
};
